import { render } from "./ExpendPay.vue?vue&type=template&id=0d2120ca"
import script from "./ExpendPay.vue?vue&type=script&lang=js"
export * from "./ExpendPay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__